<div *ngIf="showBack" class="d-flex justify-content-between my-1 p-1" style="min-height: 40px;">
    <div>
        <button mat-icon-button (click)="navBack()">
            <mat-icon>keyboard_backspace</mat-icon>
        </button>
    </div>
    <div style="align-self: center;">
        <div style="align-self: center;">{{'COCKPIT.OBJECTS.GameRecord' | translate}}</div>
    </div>
    <div></div>
</div>
<ng-template injectComp></ng-template>